/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React from 'react';
import PropTypes from 'prop-types';
import { classnames as cn } from '@ba-ui-toolkit/utils';
import styles from './GridCell.scss';

const gridHeaderCellClassName = styles.gridHeaderCellClassName.replace(/"/g, '');
const gridCellClassName = styles.gridCellClassName.replace(/"/g, '');

export function GridCell({ children, className, style, onClick, dir, ...others }) {
	const borderClassName = dir === 'rtl' ? { 'rtl-border': true } : { 'ltr-border': true };

	return (
		<div
			{...others}
			onClick={onClick}
			className={cn(gridCellClassName, className, borderClassName)}
			style={style}
		>
			{children}
		</div>
	);
}

GridCell.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node,
	onClick: PropTypes.func,
	style: PropTypes.object,
	dir: PropTypes.string,
};

export function GridHeaderCell({
	children,
	className,
	style,
	dir,
	onClick,
	onContextMenu,
	...others
}) {
	const borderClassName = dir === 'rtl' ? { 'rtl-border': true } : { 'ltr-border': true };

	return (
		<div
			{...others}
			onClick={onClick}
			onContextMenu={onContextMenu}
			className={cn(gridHeaderCellClassName, className, borderClassName)}
			style={style}
		>
			{children}
		</div>
	);
}

GridHeaderCell.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node,
	onClick: PropTypes.func,
	onContextMenu: PropTypes.func,
	style: PropTypes.object,
	dir: PropTypes.string,
};
